import Vuex from 'vuex';

export function createStore({ translations, modules, countryCode, language }) {
  return new Vuex.Store({
    modules,
    state: () => ({
      node_env: process.env.NODE_ENV,
      django_env: null,
      countryCode: countryCode,
      language: language,
      translations: translations || {},
      ssrUrl: null,
    }),
  });
}
